import { Avatar, Button, SxProps } from '@mui/material';
import { PurpleArrowLeft } from 'Images';
import { min } from 'date-fns';
import { bg } from 'date-fns/locale';

export const ActionButton = ({
  label,
  onClick,
  styleSx,
}: {
  label: string;
  onClick: () => void;
  styleSx?: SxProps;
}) => {
  const btnStyle = {
    borderRadius: '12px',
    color: 'text.primary',
    fontSize: '20px',
    fontWeight: '600',
    border: '1px solid',
    borderColor: 'primary.shade_200',
    bgcolor: 'primary.shade_100',
    p: '12px 24px',
    boxShadow: '0px 4px 12px 0px rgba(21, 82, 232, 0.08)',
    minWidth: '315px',
    display: 'flex',
    justifyContent: 'space-between',
    ...styleSx,
  };
  return (
    <Button
      endIcon={
        <Avatar
          src={PurpleArrowLeft}
          alt=''
          sx={{ width: '20px', height: '20px' }}
        />
      }
      sx={btnStyle}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};
